import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { useEffect } from "react";
import Footer from "../Home/Footer";
import samplePDF1 from "../assets/pdfs/Newsletter_1_IPDA.pdf";
import samplePDF2 from "../assets/pdfs/Newsletter_2_IPDA.pdf";
import samplePDF3 from "../assets/pdfs/Newsletter_3_IPDA.pdf";
import samplePDF4 from "../assets/pdfs/Newsletter_4_IPDA.pdf";
import NewsletterImage from "../assets/img/Latest-News_Letter.png";
import "./Newsletters.css";

const Newsletter = () => {
  useEffect(() => {
    // Initialize AOS
    const AOS = require("aos");
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="newsletter-page">
      {/* Hero Section */}
      <section
        className="newsletter-hero text-center text-light d-flex align-items-center justify-content-center"
        data-aos="fade-down"
        style={{
          backgroundImage: `url("https://static.vecteezy.com/system/resources/thumbnails/003/177/408/small/subscribe-newsletter-concept-isolated-with-news-paper-free-vector.jpg")`,
        }}
      >
        <div className="overlay"></div>
        <div className="container position-relative">
          <h1 className="display-4 fw-bold">
            Stay Updated with Our Newsletter
          </h1>
        </div>
      </section>

      {/* Newsletter Content */}
      <section className="newsletter-content py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6" data-aos="fade-right">
              <img
                src={NewsletterImage}
                alt="Newsletter"
                className="newsletter-full-image rounded shadow-lg"
              />
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <h2 className="fw-bold">Latest Newsletter</h2>
              <p>
                Dive into the most recent updates on agriculture, pest
                management, and industry trends.
              </p>

              {/* Tailwind vertical stack for buttons */}
              <div className="d-flex flex-column gap-3 mt-3">
                <a
                  href={samplePDF4}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  style={{ backgroundColor: "#d4561a", color: "white" }}
                  data-aos="zoom-in"
                >
                  📄 View June 2026 Newsletter (PDF)
                </a>
                <a
                  href={samplePDF3}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  style={{ backgroundColor: "#d4561a", color: "white" }}
                  data-aos="zoom-in"
                >
                  📄 View June 2025 Newsletter (PDF)
                </a>

                <a
                  href={samplePDF2}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  style={{ backgroundColor: "#d4561a", color: "white" }}
                  data-aos="zoom-in"
                >
                  📄 View March 2025 Newsletter (PDF)
                </a>
                <a
                  href={samplePDF1}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  style={{ backgroundColor: "#d4561a", color: "white" }}
                  data-aos="zoom-in"
                >
                  📄 View December 2024 Newsletter (PDF)
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Section: Benefits of Subscribing */}
      {/* <section
        className="featured-insights py-5"
        data-aos="fade-up"
        style={{ background: "#d4561a", color: "white" }}
      >
        <div className="container">
          <h3 className="fw-bold text-center mb-4">
            📢 Featured Insights from Our Latest Newsletter
          </h3>
          <div className="row mt-4">
            Card 1
            <div className="col-md-4" data-aos="zoom-in">
              <div className="card insight-card text-center p-3 border-0">
                <h5 className="fw-bold">🌱 Sustainable Farming Practices</h5>
                <p>
                  Discover innovative methods to improve soil health and boost
                  crop yield sustainably.
                </p>
              </div>
            </div>

            Card 2
            <div className="col-md-4" data-aos="zoom-in" data-aos-delay="200">
              <div className="card insight-card text-center p-3 border-0">
                <h5 className="fw-bold">🐛 Pest Management Strategies</h5>
                <p>
                  Learn effective ways to protect your crops from common pests
                  and diseases.
                </p>
              </div>
            </div>

            Card 3
            <div className="col-md-4" data-aos="zoom-in" data-aos-delay="400">
              <div className="card insight-card text-center p-3 border-0">
                <h5 className="fw-bold">📊 Market Trends & Insights</h5>
                <p>
                  Stay updated with the latest agricultural market trends and
                  economic forecasts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default Newsletter;
